__turbopack_context__.v({
  "Avatar": "LoggedOutView-module-scss-module__sJgfxG__Avatar",
  "Fallback": "LoggedOutView-module-scss-module__sJgfxG__Fallback",
  "Image": "LoggedOutView-module-scss-module__sJgfxG__Image",
  "closeButton": "LoggedOutView-module-scss-module__sJgfxG__closeButton",
  "content": "LoggedOutView-module-scss-module__sJgfxG__content",
  "desc": "LoggedOutView-module-scss-module__sJgfxG__desc",
  "footer": "LoggedOutView-module-scss-module__sJgfxG__footer",
  "list": "LoggedOutView-module-scss-module__sJgfxG__list",
  "listItem": "LoggedOutView-module-scss-module__sJgfxG__listItem",
  "lock": "LoggedOutView-module-scss-module__sJgfxG__lock",
  "mainBtn": "LoggedOutView-module-scss-module__sJgfxG__mainBtn",
  "modal": "LoggedOutView-module-scss-module__sJgfxG__modal",
  "modalContent": "LoggedOutView-module-scss-module__sJgfxG__modalContent",
  "name": "LoggedOutView-module-scss-module__sJgfxG__name",
  "position": "LoggedOutView-module-scss-module__sJgfxG__position",
  "primary": "LoggedOutView-module-scss-module__sJgfxG__primary",
  "root": "LoggedOutView-module-scss-module__sJgfxG__root",
  "secBtn": "LoggedOutView-module-scss-module__sJgfxG__secBtn",
  "secondary": "LoggedOutView-module-scss-module__sJgfxG__secondary",
  "sub": "LoggedOutView-module-scss-module__sJgfxG__sub",
  "tabs": "LoggedOutView-module-scss-module__sJgfxG__tabs",
  "time": "LoggedOutView-module-scss-module__sJgfxG__time",
  "title": "LoggedOutView-module-scss-module__sJgfxG__title",
});
